export const ChapterStatus = {
  IN_PROCESS : 2,
  LOCKED : 0,
  COMPLETED: 1
}